import {throwError as observableThrowError} from 'rxjs';
import {Injectable} from "@angular/core";
import {AuthService} from "./auth.service";
import {UtilitiesService} from "./utilities.service";
import {HttpClient} from '@angular/common/http';
import { API_KEYS } from '../constants';

@Injectable()
export class GeocodeService {
    baseUrl = "https://maps.googleapis.com/maps/api/geocode";
    // /json?address=1600+Amphitheatre+Parkway,+Mountain+View,+CA&key=YOUR_API_KEY"

    constructor(private http: HttpClient,
        public utilitiesService: UtilitiesService,
        public authService: AuthService) {
    }

    getCoordinates(params: any) {
        return this.http.get(this.baseUrl + "/json?address=" + params + '&key=' + API_KEYS.GOOGLE_MAPS)
            .map(this.extractData)
            .catch(this.handleError);
    } // getCoordinates

    private extractData(res: Response) {
        let body: any = res;

        if (body.status == 'OK' && body.results) {
            return body.results || {};
        } else {
            return {};
        }

    } // extractData

    private handleError(error: any) {
        // In a real world app, we might use a remote logging infrastructure
        // We'd also dig deeper into the error to get a better message
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        return observableThrowError(errMsg);

    } // handleError
}
